import { Box } from '@mui/material';
import type { FC, ReactNode } from 'react';

import { VIEW_ONLY_FIELDS_OPACITY } from '@web/constants/app';

type Props = {
  children: ReactNode;
};

export const ViewOnlyFields: FC<Props> = ({ children }) => (
  <Box
    component='fieldset'
    disabled
    sx={{
      border: 0,
      m: 0,
      p: 0,
      minWidth: 0,
      opacity: VIEW_ONLY_FIELDS_OPACITY,
      pointerEvents: 'none',
    }}
  >
    {children}
  </Box>
);
